<template>
  <v-app>
    <v-main>
      <notifications group="app"  >
      <template slot="body" slot-scope="props">
        <div class="vue-notification" :class="props.item.type">
          <div class="title" v-if="props.item.title != 'paymentLink'"  v-html="props.item.title">
          </div>  
          <div v-html="props.item.text">
          </div>
          <template v-if="props.item.title == 'paymentLink'">
            <a @click="headerClicked(5)">{{ $t('saveSuccessullyTaxes')}}</a>            
          </template>
        </div>
      </template>
    </notifications>
      <notifications group="errors"></notifications>
      <v-speed-dial v-model="fab" :direction="'top'" fixed bottom right>
        <template #activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab"> mdi-close </v-icon>
            <v-icon v-else> mdi-earth </v-icon>
          </v-btn>
        </template>
        <v-btn
          v-for="(lang, i) in langs"
          :key="`Lang${i}`"
          :value="lang"
          fab
          dark
          small
          @click="changeLang(lang)"
        >
          <span>{{ $t(lang) }}</span>
        </v-btn>
      </v-speed-dial>
      <v-btn
        v-if="!loggedIn && registering"
        style="z-index: 20; bottom: 29px"
        :title="loggedIn ? 'Logout' : 'Go to login'"
        fixed
        bottom
        left
        @click="logout()"
        :color="loggedIn ? 'red darken-2' : 'secondary'"
        dark
        fab
      >
        <v-icon> {{ loggedIn ? "mdi-logout" : "mdi-login" }} </v-icon>
      </v-btn>
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
        v-if="loading"
      ></v-progress-linear>
      <!-- choose action container -->
      <div id="authentication-card">
        <v-container
          fill-height
          v-if="
            !(registering || loggedIn) && !(recoverPassword || resetPassword)
          "
        >
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md6>
              <div class="authentication-card">
                <v-alert v-if="!loading && loadingError" type="error">
                  {{ $t(loadingError) }}
                </v-alert>
                <v-alert v-if="!loading && loginError" type="error">
                  {{ $t(loginError) }}
                </v-alert>
                <v-alert type="success" v-if="resetPerformed">{{
                        $t("passResetMessage")
                      }}</v-alert>
                <v-form
                  @submit.prevent="performLogin()"
                  ref="loginFormValid"
                  v-model="loginFormValid"
                  v-if="!loading && !loadingError"
                >
                  <v-card class="elevation-2">
                    <v-card-title>
                      {{ $t("Authentication") }}
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        name="user"
                        :label="$t('userEmail')"
                        type="text"
                        v-model="loginUser"
                        :rules="[requiredRule, emailRule]"
                      >
                      </v-text-field>
                      <v-text-field
                        id="password"
                        name="password"
                        :label="$t('password')"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="loginPass"
                        :rules="[requiredRule]"
                      >
                      </v-text-field>
                      <v-row>
                        <v-checkbox
                          class="px-2"
                          :label="$t('showPassword')"
                          v-model="showPassword"
                        >
                        </v-checkbox>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-container fluid>
                        <v-row>
                          <v-col>
                            <v-btn color="#76bf02" @click="chooseRegister()" style="color:white">
                              {{ $t("Register") }}
                            </v-btn>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col>
                            <v-btn
                              color="primary"
                              type="submit"
                              @click.prevent="performLogin()"
                            >
                              {{ $t("Login") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col style="display: flex; justify-content: center">
                            <v-btn
                              small
                              color="primary"
                              @click="recoverPassword = true"
                            >
                              {{ $t("recoverPass") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container v-if="recoverPassword">
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md6>
              <div class="authentication-card">
                <v-form
                  @submit.prevent="performRecoverPass()"
                  ref="recoverFormValid"
                  v-model="recoverFormValid"
                  v-if="!loading && !loadingError"
                >
                  <v-card class="elevation-2">
                    <v-card-title>
                      {{ $t("resetPass") }}
                    </v-card-title>
                    <v-card-text>
                      <v-alert type="success" v-if="resetSent">{{
                        $t("recoverPassEmailSentMessage")
                      }}</v-alert>
                      <v-text-field
                        name="user"
                        :label="$t('userEmail')"
                        type="text"
                        v-model="loginUser"
                        :rules="[requiredRule, emailRule]"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <div>
                      <v-row>
                        <v-col>
                        <v-btn
                          
                          color="primary"
                          type="submit"
                          @click.prevent="performRecoverPass()"
                        >
                          {{ $t("sendRecoverPass") }}
                        </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                        <v-btn
                          
                          color="primary"
                          @click="
                            recoverPassword = false;
                            resetSent = false;
                          "
                        >
                          {{ $t("back") }}
                        </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container v-if="resetPassword">
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md6>
              <div class="authentication-card">
                <v-form
                  @submit.prevent="performResetPass()"
                  ref="resetFormValid"
                  v-model="resetFormValid"
                  v-if="!loading && !loadingError"
                >
                  <v-card class="elevation-2">
                    <v-card-title>
                      {{ $t("resetPass") }}
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        name="password"
                        :label="$t('password')"
                        type="password"
                        v-model="newPass"
                        :rules="[requiredRule, min6Pass]"
                      >
                      </v-text-field>
                      <v-text-field
                        name="password"
                        :label="$t('passwordConfirm')"
                        type="password"
                        v-model="newPassConfirm"
                        :rules="[requiredRule, matchingPasswords]"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-row>
                        <v-col>
                          <v-btn
                            
                            color="primary"
                            type="submit"
                            @click.prevent="performResetPass()"
                          >
                            {{ $t("resetPass") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            
                            color="primary"
                            @click="
                              resetPerformed = undefined;
                              resetPassword = false;
                              newPass = undefined;
                              newPassConfirm == undefined;
                            "
                          >
                            {{ $t("back") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div style="display: flex;">
        <div id="loggedInMenu"
          v-if="loggedIn && !isMobile"
        >
          <v-card
            @click="headerClicked(1)"
            :class="{ header_card_selected: currentStep == 1 }"
          >
            <v-card-title>{{ $t("stepTitles.participant") }}</v-card-title>
            <v-card-text>
              <v-row dense no-gutters>
                <v-col>{{ participant.name }} {{ participant.surname }}</v-col>
              </v-row>
              <v-row dense no-gutters v-if="participantTypeText">
                <v-col>{{ participantTypeText }}</v-col>
              </v-row>
              <v-row dense no-gutters v-if="participant.city">
                <v-col>{{ participant.city }}</v-col>
              </v-row>
              <v-row dense no-gutters>
                <v-col class="text-right">{{ $t("change") }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            @click="headerClicked(2)"
            :class="{ header_card_selected: currentStep == 2 }"
          >
            <v-card-title>{{ $t("stepTitles.taxes") }}</v-card-title>
            <v-card-text>
              <v-row dense no-gutters>
                <v-col>{{ $t("taxDescription") }}</v-col>
              </v-row>
              <v-row
                dense
                no-gutters
                v-for="service in requiredServices"
                :key="service.id"
              >
                <v-col>{{ $t(service.name) }}</v-col>
              </v-row>
              <v-row
                dense
                no-gutters
                v-for="service in selectedOptionalServices"
                :key="service.id"
              >
                <v-col>{{ $t(service.name) }}</v-col>
              </v-row>
              <v-row dense no-gutters>
                <v-col class="text-right">{{ $t("change") }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            v-if="eventHotels.length > 0 && !hideHotels"
            @click="headerClicked(3)"
            :class="{ header_card_selected: currentStep == 3 }"
          >
            <v-card-title>{{ $t("stepTitles.hotel") }}</v-card-title>
            <v-card-text>
              <v-row
                dense
                no-gutters
                v-if="!selectedRooms || selectedRooms.length <= 0"
              >
                <v-col>{{ $t("noRoomsSelected") }}</v-col>
              </v-row>
              <v-row
                dense
                no-gutters
                v-for="selectedRoom in selectedRooms"
                :key="selectedRoom.roomId"
              >
                <v-col
                  >{{ getHotelName(selectedRoom.roomId) }},
                  {{ getRoomName(selectedRoom.roomId) }},
                  {{ selectedRoom.dates[0] }} -
                  {{ selectedRoom.dates[1] }}</v-col
                >
              </v-row>
              <v-row dense no-gutters>
                <v-col class="text-right">{{ $t("change") }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card v-if="!hideResume"
            @click="headerClicked(4)"
            :class="{ header_card_selected: currentStep == 4 }"
          >
            <v-card-title>{{ $t("stepTitles.resumes") }}</v-card-title>
            <v-card-text>
              <v-row
                dense
                no-gutters
                v-if="!participant.resumes || participant.resumes.length <= 0"
              >
                <v-col>{{ $t("noResumesUploaded") }}</v-col>
              </v-row>
              <v-row
                dense
                no-gutters
                v-if="participant.resumes && participant.resumes.length == 1"
              >
                <v-col>{{ $t("resumesUploaded1") }}</v-col>
              </v-row>
              <v-row
                dense
                no-gutters
                v-if="participant.resumes && participant.resumes.length > 1"
              >
                <v-col>{{
                  $t("resumesUploaded", { count: participant.resumes.length })
                }}</v-col>
              </v-row>
              <v-row dense no-gutters>
                <v-col class="text-right">{{ $t("change") }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            @click="headerClicked(5)"
            :class="{ header_card_selected: currentStep == 5 }"
          >
            <v-card-title>{{ $t("stepTitles.payments") }}</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
          <v-card @click="logout()">
            <v-card-title>{{ $t("logout") }}</v-card-title>
          </v-card>
        </div>
        <div style="flex: 1;">
          <div id="stepper-content-container">
            <!-- steps container -->
            <v-container
              class="stepper-content-container pa-0 pa-xs-12"
              v-if="
                (registering || loggedIn) &&
                !loading &&
                !loadingError &&
                !(recoverPassword || resetPassword)
              "
            >
              <v-row align="center" justify="center"> </v-row>
              <v-dialog
                v-model="confirmContinueRegistration"
                persistent
                :width="isMobile ? '100%' : '50%'"
                attach=".v-application"
                
              >
                <v-card :style="isMobile ?  'position: absolute;     top: 0px;right: 0px;' : ''">
                  <v-card-title class="text-h5">
                    {{ $t("continueRegistrationTitle") }}
                  </v-card-title>
                  <v-card-text>
                    {{ $t("continueRegistrationMessage") }}
                  </v-card-text>
                  <v-card-actions>
                    <v-container fluid>
                      <v-row>
                        <v-col>
                          <v-btn
                            color="primary"
                            variant="text"
                            @click="continueRegistration()"
                          >
                            {{ $t("continueRegistrationMessageOk") }}
                          </v-btn>
                        </v-col>
                        <v-col>
                          <v-btn
                            color="primary"
                            variant="text"
                            @click="abortRegistration()"
                          >
                            {{ $t("continueRegistrationMessageCancel") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-bottom-navigation v-if="!loading && !loadingError && isMobile && loggedIn" :style="loggedIn ? 'margin-top: 25px;justify-content:left;' : 'margin-top: 25px;'">
                <template v-if="loggedIn">
                  <v-menu open-on-hover
                    top
                    offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                      <v-app-bar-nav-icon></v-app-bar-nav-icon>{{ $t("menu") }}
                      </v-btn>
                    </template>
                    <div style="padding-top: 40px;display: flex;flex-direction: column;background: white;gap: 20px;padding: 10px;">
                        <div  @click="headerClicked(1)"
                          :class="{ header_card_selected: currentStep == 1 }">
                          {{ $t("stepTitles.participant") }}
                        </div>
                        <div @click="headerClicked(2)"
                          :class="{ header_card_selected: currentStep == 2 }">
                          {{ $t("stepTitles.taxes") }}
                        </div>
                        <div  v-if="eventHotels.length > 0 && !hideHotels" @click="headerClicked(3)"
                          :class="{ header_card_selected: currentStep == 3 }">
                          {{ $t("stepTitles.hotel") }}
                        </div>
                        <div  v-if="!hideResume" @click="headerClicked(4)"
                          :class="{ header_card_selected: currentStep == 4 }">
                          {{ $t("stepTitles.resumes") }}
                        </div>
                        <div @click="headerClicked(5)"
                          :class="{ header_card_selected: currentStep == 5 }">
                          {{ $t("stepTitles.payments") }}
                        </div>
                        <div @click="logout()">{{ $t("logout") }}</div>
                    </div>
                  </v-menu>
                </template>
              </v-bottom-navigation>
              <v-stepper
                v-model="currentStep"
                :alt-labels="true"
                id="stepper"
                :class="{ stepperRegister: !loggedIn, stepperRegister_mobile : isMobile }"
              >
                <v-stepper-header v-if="(!isMobile && !loggedIn)">
                  <v-stepper-step
                    :complete="true"
                    :class="{'not_completed': !(maxStep >= 1 || loggedIn)}"
                    step="1"
                    @click="headerClicked(1)"
                  >
                    {{ $t("stepTitles.participant") }}
                  </v-stepper-step>

                  <v-divider />

                  <v-stepper-step
                    :complete="true"
                    :class="{'not_completed': !(maxStep >= 2 || loggedIn)}"
                    step="2"
                    @click="headerClicked(2)"
                  >
                    {{ $t("stepTitles.taxes") }}
                  </v-stepper-step>

                  <v-divider />

                  <template v-if="eventHotels.length > 0 && !hideHotels">
                    <v-stepper-step
                      :complete="true"
                    :class="{'not_completed': !(maxStep >= 3 || loggedIn)}"
                      step="3"
                      @click="headerClicked(3)"
                    >
                      {{ $t("stepTitles.hotel") }}
                    </v-stepper-step>

                    <v-divider />
                  </template>

                  <template v-if="!hideResume">
                    <v-stepper-step
                      :complete="true"
                    :class="{'not_completed': !(maxStep >= 4 || loggedIn)}"
                      step="4"
                      @click="headerClicked(4)"
                    >
                      {{ $t("stepTitles.resumes") }}
                    </v-stepper-step>

                    <v-divider />
                  </template>

                  <v-stepper-step
                    :complete="true"
                    :class="{'not_completed': !(maxStep >= 5 || loggedIn)}"
                    step="5"
                    @click="headerClicked(5)"
                  >
                    {{ $t("stepTitles.payments") }}
                  </v-stepper-step>

                  <v-divider />
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <h2 class="text-center show-on-low-res">
                      {{ $t("stepTitles.participant") }}
                    </h2>
                    <participant v-if="currentStep == 1"
                      ref="partComponent"
                      @formValid="participantValid($event)"
                      @gotologin="logout()"
                      :participantTypes="serverData.participantTypes"
                      :evenName="serverData.title"
                      :fields="serverData.fields"
                      :preview="false"
                      :loggedIn="loggedIn"
                      :eventId="eventId"
                    >
                    </participant>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <h2 class="text-center show-on-low-res">
                      {{ $t("stepTitles.taxes") }}
                    </h2>
                    <taxes v-if="currentStep == 2"
                      ref="taxesComponent"
                      @formValid="taxesValid($event)"
                      :participationTypes="serverData.attendanceTypes"
                      :eventNote="serverData.note"
                      :evenName="serverData.title"
                      :eventTax="
                        eventTax && eventTax.length > 0 ? eventTax[0] : {}
                      "
                      :currency="serverData.currency"
                      :requiredServices="requiredServices"
                      :optionalServices="optionalServices"
                    ></taxes>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <h2 class="text-center show-on-low-res">
                      {{ $t("stepTitles.hotel") }}
                    </h2>
                    <hotels
                      v-if="currentStep == 3"
                      ref="hotelsComponent"
                      :hotels="eventHotels"
                      @formValid="hotelsValid($event)"
                      :currency="serverData.currency"
                      :startDate="hotelStartDate"
                      :endDate="serverData.endEventDate"
                    ></hotels>
                  </v-stepper-content>
                  <v-stepper-content step="4" >
                    <h2 class="text-center show-on-low-res">
                      {{ $t("stepTitles.resumes") }}
                    </h2>
                    <resumes v-if="currentStep == 4"
                      @dialog-shown="
                        ($event) =>
                          $event ? observeHeight(true) : observeHeight()
                      "
                      @formValid="resumesValid($event)"
                      @resumeChanges="submitFormData()"
                      :subjectOptions="resumeSubjects"
                      :presentationOptions="resumePresentationType"
                      :endDate="serverData.resumeEndDate"
                    />
                  </v-stepper-content>
                  <v-stepper-content step="5">
                    <h2 class="text-center show-on-low-res">
                      {{ $t("stepTitles.summary") }}
                    </h2>
                    <v-alert v-if="registerParticipantError" type="error">{{
                      $t(registerParticipantError)
                    }}</v-alert>
                    <preview
                      ref="preview"
                      v-if="currentStep == 5"
                      :participantTypes="serverData.participantTypes"
                      @onfinaliseclicked="onFinalizeClicked()"
                      @onlogoutclicked="logout()"
                      :evenName="serverData.title"
                      :eventTax="
                        eventTax && eventTax.length > 0 ? eventTax[0] : {}
                      "
                      :currency="serverData.currency"
                      :requiredServices="requiredServices"
                      :optionalServices="optionalServices"
                      :hotels="eventHotels"
                      :payments="modelPayments"
                      :loggedIn="loggedIn"
                      :showEmailField="showEmailField"
                      :justRegistered="justRegistered"
                      :modelPayment="modelPayment"
                      :serverData="serverData"
                      :companyDataSchema="companyDataSchema"
                    >
                    </preview>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
              <v-bottom-navigation v-if="!loading && !loadingError">
                <v-btn color="primary" @click="prevAction()" v-if="currentStep > 1 && !loggedIn">
                  {{ $t("Back") }}
                </v-btn>
                <v-btn color="primary" v-if="currentStep < 5" @click="loggedIn ? switchStep(currentStep) : nextAction()">
                  {{ $t(loggedIn ? "saveChanges" : "Continue") }}
                </v-btn>
              </v-bottom-navigation>
            </v-container>
          </div>
        </div>
      </div>
    </v-main>
    <v-form
      method="POST"
      ref="onlinePayform"
      id="onlinePayform"
      action="https://secure.euplatesc.ro/tdsprocess/tranzactd.php"
    >
      <input type="hidden" name="amount" v-model="onlinePaymentInfo.amount" />
      <input type="hidden" name="curr" v-model="onlinePaymentInfo.curr" />
      <input
        type="hidden"
        name="invoice_id"
        v-model="onlinePaymentInfo.invoiceId"
      />
      <input
        type="hidden"
        name="order_desc"
        v-model="onlinePaymentInfo.orderDesc"
      />
      <input
        type="hidden"
        name="merch_id"
        v-model="onlinePaymentInfo.merchId"
      />
      <input
        type="hidden"
        name="timestamp"
        v-model="onlinePaymentInfo.timestamp"
      />
      <input type="hidden" name="nonce" v-model="onlinePaymentInfo.nonce" />
      <input type="hidden" name="fp_hash" v-model="onlinePaymentInfo.fpHash" />
      <input type="hidden" name="fname" v-model="participant.name" />
      <input type="hidden" name="lname" v-model="participant.surname" />
      <input type="hidden" name="phone" v-model="participant.mobile" />
      <input type="hidden" name="email" v-model="participant.email" />
      <input
        type="hidden"
        name="ExtraData"
        v-model="onlinePaymentInfo.extraData"
      />
      <input type="hidden" name="ExtraData[ep_target]" value="self" />
    </v-form>
  </v-app>
</template>

<script>
// import VJsf from "@koumoul/vjsf/lib/VJsf.js";
// import "@koumoul/vjsf/lib/VJsf.css";
// import "@koumoul/vjsf/lib/deps/third-party.js";
import moment from "moment";
import axios from "axios";
import Participant from "./components/Participant.vue";
import Taxes from "./components/Taxes.vue";
import { participant, resetParticipant } from "@/model/participant";
import Hotels from "./components/Hotels.vue";
import Resumes from "./components/Resumes.vue";
import Preview from "./components/Preview.vue";
import { eventerApi } from "./utils/apiController.js";
import Vue from 'vue';
import { matchParticipantCondition } from './utils/utils';

export default {
  name: "App",
  components: { Participant, Taxes, Hotels, Resumes, Preview },
  data: () => ({
    timerAlertPrezent : false,
    isMobile:
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ),
    drawer: null,
    showPassword: false,
    resetSent: false,
    recoverPassword: false,
    recoverFormValid: undefined,
    resetFormValid: undefined,
    showResetPass: false,
    newPassConfirm: undefined,
    resetPerformed: false,
    newPass: undefined,
    resetPassword: false,
    minParentHeight: 400,
    resizeObserver: undefined,
    eventerApi,
    participant,
    oldparticipant: "",
    resetParticipant,
    fab: false,
    fling: false,
    langs: ["ro", "en"],
    loginUser: "",
    loginPass: "",
    options: {
      locale: "ro",
      context: {
        showCnp: true,
        showCui: true,
      },
    },
    loggedIn: false,
    registering: false,
    justRegistered: false,
    loginError: undefined,
    loading: true,
    eventId: undefined,
    loadingError: undefined,
    registerParticipantError: undefined,
    payentParticipantError: undefined,
    loginFormValid: false,
    panel: [0],
    elevation: 10,
    changes: false,
    valid: [false, false, false, false, false, true, false],
    currentStep: 1,
    submitStep: 5,
    lastStep: 5,
    paymentStep: 5,
    maxStep: 0,
    submitted: false,
    participantId: undefined,
    showEmailField: false,
    modelPayment: { addCompanyData: false, bankProof: undefined },
    onlinePaymentInfo: {
      amount: undefined,
      curr: undefined,
      invoiceId: undefined,
      orderDesc: undefined,
      merchId: undefined,
      timestamp: undefined,
      nonce: undefined,
      fpHash: undefined,
      extraData: undefined,
    },
    modelPayments: [],
    serverData: {},
    companyDataSchema: {
      title: {
        $ref: "#/i18n/~$locale~/companyData",
      },
      desc: {
        $ref: "#/i18n/~$locale~/companyData",
      },
      type: "object",
      required: [
        "name",
        "fiscalCode",
        "bank",
        "address",
        "city",
        "registryNumber",
      ],
      properties: {
        name: {
          title: {
            $ref: "#/i18n/~$locale~/compName",
          },
          type: "string",
        },
        fiscalCode: {
          title: {
            $ref: "#/i18n/~$locale~/fiscalCode",
          },
          type: "string",
        },
        registryNumber: {
          title: {
            $ref: "#/i18n/~$locale~/registryNumber",
          },
          type: "string",
        },
        address: {
          title: {
            $ref: "#/i18n/~$locale~/address",
          },
          type: "string",
        },
        city: {
          title: {
            $ref: "#/i18n/~$locale~/participantCity",
          },
          type: "string",
        },
        bank: {
          title: {
            $ref: "#/i18n/~$locale~/bank",
          },
          type: "string",
        },
      },
    },
    currentContentHeight: null,
    timer: null,
    inactivityAlert: 300000, //300000,
    confirmContinueRegistration: true,
    hideHotels: false,
  }),
  computed: {
    participantTypeText: function () {
      if (this.participant.participantType) {
        const participantTypeObj = this.participantTypes.find(
          (p) => p.id == this.participant.participantType
        );
        if (participantTypeObj) {
          return this.$t(participantTypeObj.name);
        }
      }
      return undefined;
    },
    eventTax: function () {
      let result = [{}];
      if (this.hasParticipantServerData()) {
        result = this.serverData[this.participant.participantType].eventTax;
        if (result && result.length > 0) {
          return result;
        } else {
          return [{}];
        }
      }
      return result;
    },
    requiredServices: function () {
      let result = [];
      
      if (this.hasParticipantServerData()) {
        result = this.getMatchedServices(this.serverData[
          this.participant.participantType
        ].requiredServiceClasses);
      }
      return  result;
    },
    optionalServices: function () {
      let result = [];
      
      if (this.hasParticipantServerData()) {
        result = this.getMatchedServices(this.serverData[
          this.participant.participantType
        ].optionalServiceClasses);
      }
      return  result;
    },
    eventHotels: function () {
      if (this.hasParticipantServerData()) {
        return this.serverData[this.participant.participantType].eventHotels;
      }
      return [];
    },
    selectedOptionalServices: function () {
      let result = [];
      this.optionalServices.forEach((service) => {
        if (
          this.participant.services.selectedServices.findIndex(
            (s) => s.serviceId == service.id
          ) > -1
        ) {
          result.push(service);
        }
      });
      return result;
    },
    selectedRooms: function () {
      return this.participant.rooms.selectedRooms;
    },
    resumes: function () {
      return this.participant.resumes;
    },
    participantTypes: function () {
      return this.serverData.participantTypes
        ? this.serverData.participantTypes
        : [];
    },
    requiredServicesPrice: function () {
      let totalPrice = 0;
      this.requiredServices.forEach((service) => {
        totalPrice = totalPrice + service.price;
      });
      return totalPrice;
    },
    optionalServicesPrice: function () {
      let totalPrice = 0;
      this.optionalServices.forEach((service) => {
        if (
          this.participant.services.selectedServices.findIndex(
            (s) => s.serviceId == service.id
          ) > -1
        ) {
          totalPrice = totalPrice + service.price;
        }
      });
      return totalPrice;
    },
    totalPriceServices: function () {
      let totalPrice = 0;
      if (this.eventTax && this.eventTax[0]) {
        if (
          this.eventTax[0].taxAmounts &&
          this.eventTax[0].taxAmounts.length > 0
        ) {
          totalPrice =
            totalPrice +
            this.eventTax[0].taxAmounts[this.taxAmountIndex]?.amount;
        }
      }
      totalPrice = totalPrice + this.requiredServicesPrice;
      totalPrice = totalPrice + this.optionalServicesPrice;

      return totalPrice;
    },
    taxAmountIndex: function () {
      let index = undefined;
      this.eventTax[0].taxAmounts.forEach((taxObj, i) => {
        if (
          taxObj.attendanceType.id ==
          this.participant.services.participationType
        ) {
          index = i;
        }
      });
      return index;
    },
    totalRoomPrice: function () {
      let totalPrice = 0;
      if (this.selectedRooms) {
        this.selectedRooms.forEach((selectedRoom) => {
          totalPrice = totalPrice + this.oneRoomPrice(selectedRoom.roomId);
        });
      }
      return totalPrice;
    },
    extendedSelectedRooms: function () {
      let extendedSelectedRooms = [];
      this.eventHotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          let selectedIdx = this.selectedRoomIndex(room.id);
          if (selectedIdx >= 0) {
            let selectedDates = this.selectedRooms[selectedIdx].dates;
            let interval = "";
            if (selectedDates && selectedDates.length > 0) {
              let startDate = moment(selectedDates[0], "YYYY-MM-DD");
              let endDate = startDate;
              interval = selectedDates[0];
              if (selectedDates.length > 1) {
                endDate = moment(selectedDates[1], "YYYY-MM-DD");
                interval = interval + " - " + selectedDates[1];
              }
              let nights = Math.abs(endDate.diff(startDate, "days"));
              extendedSelectedRooms.push({
                hotel: hotel.name,
                room: room.name,
                interval: interval,
                nights: nights,
                price: nights * room.price,
              });
            }
          }
        });
      });
      return extendedSelectedRooms;
    },
    completeModel: function () {
      let completeModel = {};
      Object.assign(completeModel, this.participant);
      Object.assign(completeModel.services, this.participant.services);
      Object.assign(completeModel.rooms, this.participant.rooms);
      return completeModel;
    },
    resumeSubjects: function () {
      const participantSubjects = [];

      this.serverData.themes.forEach((subject) => {
        if (
          subject.participantTypes.some(
            (pType) => pType.id === this.participant.participantType
          )
        ) {
          participantSubjects.push({ id: subject.id, name: subject.name });
        }
      });

      return participantSubjects;
    },
    resumePresentationType: function () {
      return this.serverData.presentationTypes;
    },
    hotelStartDate: function () {
      const serverDate = moment(this.serverData.startEventDate, "YYYY-MM-DD");
      const now = moment();
      const result = now.isAfter(serverDate)
        ? moment().format("YYYY-MM-DD")
        : this.serverData.startEventDate;
      return result;
    },
    hideResume :function(){
      if(this.serverData.themes && this.serverData.themes.length > 0 ) {
        //request was made to not actually hide the page
        //if(this.participant && this.participant.resumes && this.participant.resumes.length>0){
          return false;
        //}
        // if(!this.serverData.resumeEndDate){
        //   return false;
        // }
        // const endDateDate = moment(this.serverData.resumeEndDate, "YYYY-MM-DD");
        // const now = moment();
        // return now.isAfter(endDateDate);
      }else{
        return true;
      }
    }
  },
  methods: {
    getMatchedServices( allServiceClasses){
      let result = [];
      let resultExclusive = [];
      
      allServiceClasses.forEach((serviceClass) => {
        if(!matchParticipantCondition(this.participant, serviceClass.conditionScript )){
          return;
        }

        serviceClass.services.forEach((service) => {
          if(!matchParticipantCondition(this.participant, service.conditionScript )){
            return;
          }
          if(serviceClass.exclusive || service.exclusive) {
            resultExclusive.push(service);
          }else{
            result.push(service);
          }
        });
      });
      return resultExclusive && resultExclusive.length > 0 ?  resultExclusive : result;
    },
    calculateHiddenHotels(){
      if (participant.services && participant.services.participationType) {
            const attendanceType = this.serverData.attendanceTypes.find(
              (x) => x.id == participant.services.participationType
            );
            if (attendanceType) {
              this.hideHotels = attendanceType.hideHotels;
            }
      }
    },
    getHotelName(roomId) {
      for (let hotel of this.eventHotels) {
        if (hotel.rooms.find((r) => r.id == roomId)) {
          return this.$t(hotel.name);
        }
      }
    },
    getRoomName(roomId) {
      for (let hotel of this.eventHotels) {
        const room = hotel.rooms.find((r) => r.id == roomId);
        if (room) {
          return this.$t(room.name);
        }
      }
    },
    emailRule: function (value) {
      // Regular expression pattern for email validation
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Test the email against the pattern and return the result
      if (pattern.test(value)) {
        return true;
      } else {
        return this.$t("error.emailFormat");
      }
    },
    continueRegistration: function () {
      this.confirmContinueRegistration = false;
      this.chooseRegister();
      if (localStorage.participant) {
        this.setFromLocalStorage("participant");
      }

      if (localStorage.currentStep) {
        const storageStep = parseInt(localStorage.currentStep);
        if (!isNaN(storageStep)) {
          //this.currentStep = storageStep;
          this.maxStep = parseInt(localStorage.maxStep);
        }
      }
    },
    abortRegistration: function () {
      this.confirmContinueRegistration = false;
      this.logout();
    },
    requiredRule: function (value) {
      if (value != undefined) {
        return true;
      } else {
        return this.$t("error.required");
      }
    },
    min6Pass: function (value) {
      if (value != null && value.length >= 6) {
        return true;
      } else {
        return this.$t("error.minPass");
      }
    },
    matchingPasswords: function () {
      if (this.newPass === this.newPassConfirm) {
        return true;
      } else {
        return this.$t("error.passMissmatch");
      }
    },
    goToLoginPage() {
      this.justRegistered = false;
      this.loginUser = undefined;
      this.loginPass = undefined;
      this.registering = false;
      this.submitted = false;
      this.currentStep = 1;
      this.maxStep = 1;
      localStorage.clear();
      Object.assign(
        this.participant,
        JSON.parse(JSON.stringify(this.resetParticipant))
      );
      this.participant.participantType = undefined;
      this.participant.services.participationType = undefined;
    },
    sendContentHeightToParent: function (height) {
      //set 400 at minim height
      let actualHeight = Math.max(this.minParentHeight, height);
      const element = window.document.getElementById('loggedInMenu');
      if(element) {
        const heightMenu = element.offsetHeight;
        actualHeight = Math.max(actualHeight, heightMenu);
      }
      window.parent.postMessage(
        {
          contentHeight: actualHeight,
        },
        "*"
      );
    },
    observeHeight(isDialog = false) {
      //disconnect from all observers
      if (this.resizeObserver != undefined) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver((entries) => {
        let contentHeight = 0;
        entries.forEach((entry) => {
          if (entry.target.className != "container fill-height") {
            contentHeight += entry.contentRect.height;
          }
        });
        this.sendContentHeightToParent(Math.floor(contentHeight));
      });

      if (
        window.document.querySelector("#stepper-content-container") != undefined
      ) {
        this.resizeObserver.observe(
          window.document.querySelector("#stepper-content-container")
        );
      } else if (
        window.document.querySelector("#authentication-card") != undefined
      )
        this.resizeObserver.observe(
          window.document.querySelector("#authentication-card")
        );

      if (isDialog == true) {
        this.sendContentHeightToParent(this.minParentHeight);
      }
    },
    participantValid: function (valid) {
      this.valid[1] = valid;
      //this.saveParticipantToLocal();
    },
    taxesValid: function (valid) {
      this.valid[2] = valid;
      this.calculateHiddenHotels();
      this.saveParticipantToLocal();
    },
    hotelsValid: function (valid) {
      this.valid[3] = valid;
      this.saveParticipantToLocal();
    },
    resumesValid: function (valid) {
      this.valid[4] = valid;
      this.saveParticipantToLocal();
    },
    paymentValid: function (valid) {
      this.valid[6] = valid;
      this.saveParticipantToLocal();
    },
    saveParticipantToLocal() {
      const clone = JSON.parse(JSON.stringify(this.participant));
      clone.password = undefined;
      clone.confirmPassword = undefined;
      this.saveToLocalStorageVal("participant", clone);
    },
    chooseRegister: function () {
      this.justRegistered = false;
      this.drawer = false;
      this.setFromLocalStorage("modelPayment");
      this.registering = true;
      this.saveToLocalStorage("registering");
      this.$watch(
        "participant",
        () => {
          this.saveParticipantToLocal();
          this.calculateHiddenHotels();
        },
        { deep: true }
      );
      this.setupNewInactivityTimer();
    },
    clearInactivityTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    setupNewInactivityTimer() {
      this.clearInactivityTimer();
      if (this.registering) {
        this.timer = setTimeout(() => {
          if(!this.timerAlertPrezent && !this.loggedIn && this.registering) {
            this.timerAlertPrezent = true;
            const confirmText = this.$t("inactivityConfirmText");
            if (!window.confirm(confirmText)) {
              this.timerAlertPrezent = false;
              this.logout();
            }
            this.timerAlertPrezent = false;
            this.setupNewInactivityTimer();
          }
        }, this.inactivityAlert);
      }
    },
    handleUserActivity() {
      if(this.registering){
        this.setupNewInactivityTimer();
      }
    },
    performLogin: function () {
      this.$refs.loginFormValid.validate();
      if (this.loginFormValid) {
        this.login(this.loginUser, this.loginPass, true);
        this.loginUser = "";
        this.loginPass = "";
      }
    },
    performRecoverPass: function () {
      this.$refs.recoverFormValid.validate();
      if (!this.recoverFormValid) {
        return;
      }
      this.loading = true;
      axios
        .post(
          process.env.VUE_APP_BACKEND +
            "participant/registration/sendresetpasswordemail/" +
            this.eventId,
          { email: this.loginUser },
          { maxRedirects: 0 }
        )
        .then((response) => {
          console.log(response);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.resetSent = true;
    },
    performResetPass: function () {
      this.loading = true;
      this.$refs.resetFormValid.validate();
      if (!this.resetFormValid) {
        return;
      }
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const token = params.get("token");
      let request = {
        async: true,
        crossDomain: true,
        url:
          process.env.VUE_APP_BACKEND +
          "participant/registration/resetpassword/" +
          this.eventId,
        method: "post",
        data: { password: this.newPass },
        params: { token: token },
      };
      axios(request)
        .then((response) => {
          this.resetPassword = false;
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.resetPerformed = true;
    },
    incrementCurrentStep() {
      this.currentStep = this.currentStep + 1;
      //skip hotels
      if (
        this.currentStep == 3 &&
        (this.eventHotels?.length == 0 || this.hideHotels)
      ) {
        this.incrementCurrentStep();
      }
      //skip resumes
      if (
        this.currentStep == 4 &&
        (this.hideResume)
      ) {
        this.incrementCurrentStep();
      }
    },
    decrementCurrentStep() {
      this.currentStep = this.currentStep - 1;
      //skip hotels
      if (
        this.currentStep == 3 &&
        (this.eventHotels?.length == 0 || this.hideHotels)
      ) {
        this.decrementCurrentStep();
      }
      if (
        this.currentStep == 4 &&
        (this.hideResume)
      ) {
        this.decrementCurrentStep();
      }
    },
    handleUserSummit: function (submitPayment) {
      this.loading = true;
      // TODO: if user was not submitted already make a post request to register the user
      if (this.submitted == false) {
        // this.loading = true;
        axios
          .post(
            process.env.VUE_APP_BACKEND +
              "participant/registration/register/" +
              this.eventId,
            this.completeModel,
            { maxRedirects: 0, withCredentials: true }
          )
          .then((response) => {
            this.clearInactivityTimer();
            this.justRegistered = true;
            this.registerParticipantError = undefined;
            this.participantId = response.data.id;
            this.submitted = true;
            // this.loading = false;
            // set user as logged in, since the request logged the new user in
            this.loggedIn = true;
            this.cleanLocalStorage();
            localStorage.clear();
            const hasWarning = 
              (response.data.failedRooms && response.data.failedRooms.length > 0)
              ||(response.data.failedServices && response.data.failedServices.length > 0);
            this.showRoomRegistrationWarnings(response.data.failedRooms);
            this.showServiceRegistrationWarnings(response.data.failedServices);
            // login the user
            this.login(
              this.completeModel.email,
              this.completeModel.password,
              false,
              submitPayment && !hasWarning
            );
            if(hasWarning){
              this.loadEventData();
            }
          })
          .catch((error) => {
            if (error.response.status == 409) {
              // this.loading = false;
              this.showEmailField = true;

              const scrollAndFocus = new Promise((resolve) => {
                this.$refs.preview.$refs.participant.$refs.participantEmail?.$el.scrollIntoView(
                  {
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  }
                );

                setTimeout(() => {
                  resolve();
                }, 250);
              });

              scrollAndFocus.then(() =>
                this.$refs.preview.$refs.participant.$refs.participantEmail.focus()
              );

              this.registerParticipantError = error.response.data.message;
            } else {
              console.log(error.response);
              // this.loading = false;
              this.registerParticipantError = error.response.data.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    scrollElementInView: function (elementSelector) {
      const htmlElement = document.querySelectorAll(elementSelector)[0];
      if (htmlElement) {
        htmlElement?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
      htmlElement?.focus();
    },
    login: function (email, password, changeStep, submitPayment) {
      // this.loading = true;
      const data = {
        username: email,
        password: password,
        eventId: this.eventId,
      };
      this.loading = true;
      axios
        .post(process.env.VUE_APP_BACKEND + "participant/login", data, {
          maxRedirects: 0,
          withCredentials: true,
        })
        .then((response) => {
          this.setLoginToken(response.data);
          this.getParticipantInfo(changeStep, submitPayment);
        })
        .catch((error) => {
          console.log("Login error", error);
          // this.loading = false;
          this.loginError = "Unable to login";
          localStorage.clear();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showServiceRegistrationWarnings(failedServices) {
      if(failedServices && failedServices.length > 0){
        failedServices.forEach(errorService=>{
            const serviceId = errorService.serviceId;
            const service = this.optionalServices.find(s=>s.id == serviceId);
            if(service){
              Vue.notify({
              group: 'errors',
              title: '',
              text: this.$t('failedToSaveServiceDueToMax', {serviceName : this.$t(service.name)} ),
              type: 'warn', // You can customize the type (success, error, warn, info)
              duration: this.isMobile?1000:-1,
              position: 'top', // Position at the top of the page
            });
            }
          });
        }
    },
    showRoomRegistrationWarnings(failedRooms){
      if(failedRooms && failedRooms.length > 0){
        failedRooms.forEach(errorRoom=>{
          const roomId = errorRoom.roomId;
          const roomName = this.getRoomName(roomId);
          if(roomName){
            Vue.notify({
            group: 'errors',
            title: '',
            text: this.$t('failedToSaveRoomDueToMax', {roomName : this.$t(roomName)} ),
            type: 'warn', // You can customize the type (success, error, warn, info)
            duration: this.isMobile?1000:-1,
            position: 'top', // Position at the top of the page
          });
          }
        });
      }
    },
    updateParticipantInfo: function (data) {
      this.updateParticipantData("user/info", data, 1);
    },
    updateParticipantServices: function (data) {
      this.updateParticipantData("user/services", data, 2, true);
    },
    updateParticipantRooms: function (data) {
      this.updateParticipantData("user/rooms", data, 3);
    },
    updateParticipantResumes: function (data) {
      this.updateParticipantData("user/resumes", data, 4);
    },
    updateParticipantData: function (url, data, step, paymentLink) {
      const strParticipant = JSON.stringify(this.participant);
      //no changes
      if(strParticipant== this.oldparticipant){
        return;
      }
      this.oldparticipant = strParticipant;
      this.loading = true;
      axios
        .post(process.env.VUE_APP_BACKEND + url, data, {
        })
        .then((response) => {
          if (
            (typeof response.data === "string" ||
              response.data instanceof String) &&
            response.data.length > 0
          ) {
            this.loginError = "Please Relogin";
            this.loggedIn = false;
          } else {
            this.getParticipantInfo(false);
            this.loading = false;
            let successSaved = false;
            if(url == 'user/services') {
              const data = response.data;
              successSaved = !data || data.length == 0;
              this.showServiceRegistrationWarnings(data)
            }
            if(url == 'user/rooms') {
              const data = response.data;
              successSaved = !data || data.length == 0;
              this.showRoomRegistrationWarnings(data);
            }
            if(successSaved){
              Vue.notify({
                group: 'app',
                title: paymentLink ? 'paymentLink' : '',
                text: this.$t('savedSuccessfully'),
                type: 'success', // You can customize the type (success, error, warn, info)
                duration: this.isMobile?1000:-1,
                position: 'top', // Position at the top of the page
                paymentLink : paymentLink
              });
            }else{
              this.loadEventData(false);
            }
            this.changes = false;
          }
        })
        .catch((error) => {
          console.log(
            "Login error we must check the error code , if it's 403 we must setup login",
            error
          );
          if (error.code == 403) {
            this.loginError = "Please Relogin";
            this.loggedIn = false;
          } else {
            this.currentStep = step;
            this.errorMessages = "Datele nu au putut fi salvate";
          }
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getParticipantInfo: function (changeStep, submitPayment) {
      if (this.loggedIn) {
        this.loading = true;

        axios
          .get(process.env.VUE_APP_BACKEND + "user/info", {
          })
          .then((response) => {
            if (
              typeof response.data === "string" ||
              response.data instanceof String
            ) {
              this.loginError = "Unable to login";
              localStorage.clear();
              this.loggedIn = false;
            } else {
              Object.assign(this.participant, response.data);
              Object.assign(this.modelPayments, response.data.payments);
              if(this.serverData.attendanceTypes && this.serverData.attendanceTypes.length == 1){
                if(!this.participant.services.participationType){
                  this.participant.services.participationType = this.serverData.attendanceTypes[0].id;
                }
              }
              this.oldparticipant=JSON.stringify(this.participant);
              this.changes = false;
              this.valid = [true, true, true, true, true, true, false];
              //set user as loged in the user
              // this.loggedIn = true;
              // this.registering = false;
              this.loginError = "";
              if (changeStep) {
                this.currentStep = this.submitStep;
              }
              if (submitPayment) {
                this.handlePaymentSummit();
              }
            }
          })
          .catch((error) => {
            console.log("Participantinfo error", error);
            this.loading = false;
            this.loggedIn=false;
            //this.loginError = "Unable to login";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    forceRerender : async function() {
      this.loading = true;
      // Wait for the change to get flushed to the DOM
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    getParticipantPayments: function (successCallback) {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_BACKEND + "user/payments", {          
        })
        .then((response) => {
          if (
            typeof response.data === "string" ||
            response.data instanceof String
          ) {
            this.loggedIn = false;
          } else {
            this.modelPayments = response.data;
            Vue.set(this.participant,"payments",response.data);
            this.forceRerender();
            successCallback();
          }
        })
        .catch(() => {
          this.loading = false;
          this.loggedIn = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitPayment(){
      return this.modelPayment.paymentMethod && this.modelPayment.paymentMethod!='LATER'
    },
    handlePaymentSummit: function () {
      if(!this.submitPayment()){
        this.currentStep = this.submitStep;
        return;
      }
      if (this.modelPayment.checkedServices) {
        this.modelPayment.payedServiceReservation = [];
        this.modelPayment.checkedServices.forEach((selectedServ) => {
          //find reservation
          let serviceWithReservation =
            this.participant.services.selectedServices.find(
              (s) => s.serviceId == selectedServ.id
            );
          if (serviceWithReservation) {
            this.modelPayment.payedServiceReservation.push(
              serviceWithReservation.serviceReservationId
            );
          }
        });
      }
      if (this.modelPayment.checkedRooms) {
        this.modelPayment.payedRoomReservation = [];

        this.modelPayment.checkedRooms.forEach((selectedRoom) => {
          if (selectedRoom.reservationId) {
            this.modelPayment.payedRoomReservation.push(
              selectedRoom.reservationId
            );
          } else {
            //find reservation by room id selectedRoom.roomId
            let withReservation = this.participant.rooms.selectedRooms.find(
              (room) => room.roomId == selectedRoom.roomId
            );
            if (withReservation) {
              this.modelPayment.payedRoomReservation.push(
                withReservation.roomReservationId
              );
            }
          }
        });
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      this.sendContentHeightToParent(1100);
      if (this.modelPayment.bankProof) {
        this.modelPayment.bankProof = {
          data: this.modelPayment.bankProof.data,
          name: this.modelPayment.bankProof.name,
          size: this.modelPayment.bankProof.size,
          type: this.modelPayment.bankProof.type,
        };
      }
      this.loading = true;
      axios
        .post(
          process.env.VUE_APP_BACKEND + "user/registerPayment/",
          this.modelPayment,
          { }
        )
        .then((response) => {
          this.modelPayment = { addCompanyData: false, bankProof: undefined };
          this.payentParticipantError = undefined;
          this.loading = false;
          if (response.data.invoiceId) {
            Object.assign(this.onlinePaymentInfo, response.data);

            this.$nextTick(() => {
              this.$refs.onlinePayform.$el.submit();
            });
          } else {
            this.getParticipantPayments(() => {
              this.currentStep = this.submitStep;
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.payentParticipantError =
            "Nu a putut fi salvata metoda de plata.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    headerClicked: function (step) {
      //for not logged in user, allow to go to back steps even if the current formm is not valid
      if (!this.loggedIn && step < this.currentStep) {
        this.switchStep(step, true);
      } else if (!this.loggedIn && step <= this.maxStep) {
        this.switchStep(step);
      } else if (!this.loggedIn && step == this.currentStep + 1) {
        this.switchStep(step);
      } else if (this.loggedIn) {
        this.switchStep(step);
      }
    },
    nextAction: function () {
      this.switchStep();
    },
    switchStep(step = undefined, noValidation = false) {
      Vue.notify({
      group: 'app',
      clear: true
    });
      this.justRegistered = false;
      this.reactToHotelsChange();
      this.scrollElementInView(".v-input .error--text");
      if (noValidation) {
        if (step == -1) {
          this.decrementCurrentStep();
        } else {
          this.currentStep = step;
        }
      } else if (this.valid[this.currentStep]) {
        // TODO: Submit the form data even when the step is defined (when switching from the header)
        this.submitFormData();
        if (
          this.currentStep == this.submitStep &&
          step == undefined &&
          this.registering
        ) {
          this.handleUserSummit();
        } else if (this.currentStep == this.paymentStep && step == undefined) {
          this.handlePaymentSummit();
        } else {
          if (step != undefined) {
            this.currentStep = step;
          } else {
            this.incrementCurrentStep();
          }
        }
      } else if (this.currentStep == 1) {
        this.$refs.partComponent.validate();
      } else if (this.currentStep == 2) {
        this.$refs.taxesComponent.validate();
      } else if (this.currentStep == 3) {
        this.$refs.hotelsComponent.validate();
      }

      if (this.maxStep < this.currentStep) {
        this.maxStep = this.currentStep;
      }
      this.changes = false;
    },
    prevAction: function () {
      //for not logged in user, allow prev even when the form is not vallid
      this.switchStep(-1, true);
    },
    onFinalizeClicked: function () {
      if (this.loggedIn) {
        this.handlePaymentSummit();
      } else {
        //register user and then submit payement
        this.handleUserSummit(this.submitPayment());
      }
    },
    onPayClicked: function () {
      this.handlePaymentSummit();
    },
    submitFormData() {
      if (this.loggedIn && this.valid[this.currentStep]) {
        //we have changes, so submit those to the server
        switch (this.currentStep) {
          case 1:
            this.updateParticipantInfo(this.participant);
            break;
          case 2:
            this.updateParticipantServices(this.participant.services);
            break;
          case 3:
            this.updateParticipantRooms(this.participant.rooms);
            break;
          case 4:
            this.updateParticipantResumes(this.participant.resumes);
            break;
          case 6:
            break;
          default:
            break;
        }
        this.changes = false;
      }
    },
    hasParticipantServerData: function () {
      return (
        this.participant.participantType &&
        this.serverData &&
        this.serverData[this.participant.participantType]
      );
    },
    isRoomSelected: function (roomId) {
      return this.selectedRoomIndex(roomId) > -1;
    },
    selectedRoomIndex: function (roomId) {
      for (var i = 0; i < this.selectedRooms.length; i++) {
        if (this.selectedRooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    roomSelected: function (roomId) {
      const index = this.selectedRoomIndex(roomId);
      if (index > -1) {
        this.selectedRooms.splice(index, 1);
      } else {
        this.selectedRooms.push({
          roomId: roomId,
          dates: [this.hotelStartDate, this.serverData.endDate],
        });
      }
    },
    oneRoomPrice: function (roomId) {
      let totalPrice = 0;
      this.eventHotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          if (room.id === roomId) {
            let selectedIdx = this.selectedRoomIndex(room.id);
            if (selectedIdx >= 0) {
              let selectedDates = this.selectedRooms[selectedIdx].dates;
              if (selectedDates) {
                if (selectedDates.length > 0) {
                  let startDate = moment(selectedDates[0], "YYYY-MM-DD");
                  let endDate = startDate;
                  if (selectedDates.length > 1) {
                    endDate = moment(selectedDates[1], "YYYY-MM-DD");
                  }
                  let nights = Math.abs(endDate.diff(startDate, "days"));
                  totalPrice = totalPrice + nights * room.price;
                } else {
                  let nights = 1;
                  totalPrice = totalPrice + nights * room.price;
                }
              }
            }
          }
        });
      });
      return totalPrice;
    },
    cleanLocalStorage() {
      localStorage.removeItem("modelPayment");
      localStorage.removeItem("participant");
    },
    saveToLocalStorage: function (name) {
      this.saveToLocalStorageVal(name, this[name]);
    },
    saveToLocalStorageVal: function (name, val) {
      if (val) {
        if (typeof val == "object") {
          localStorage.setItem(name, JSON.stringify(val));
        } else {
          localStorage.setItem(name, val);
        }
      } else {
        localStorage.removeItem(name);
      }
    },
    setFromLocalStorage: function (name) {
      let val = localStorage.getItem(name);
      if (val) {
        if (typeof this[name] == "object") {
          Object.assign(this[name], JSON.parse(val));
        } else {
          this[name] = val;
        }
      }
    },
    formatPlaymentDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    formatPlaymentType(type) {
      switch (type) {
        case "CARD":
          return "Card Online";
        case "BANK":
          return "Transfer bancar";
        default:
          return "";
      }
    },
    getPlaymentStatusColor(status) {
      switch (status) {
        case "APPROVED":
          return "green";
        // TODO: 'case' with 'return' values needs to be switched
        case "red":
          return "Transfer bancar";
        default:
          return "orange";
      }
    },
    formatPlaymentStatus(status) {
      return this.$t(status);
    },
    changeLang(lang) {
      //this.$vuetify.lang.current = lang;
      this.$i18n.locale = lang;
      this.options.locale = lang;
      this.translateCompanyData();
    },
    changeTableHeaderLang(tableHeader) {
      tableHeader.forEach((h) => {
        h.text = this.$t(h.value);
      });
    },
    reactToHotelsChange() {
      if (this.currentStep == 3) {
        this.$refs.hotelsComponent.notFirstLoad();
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    logout() {
      this.justRegistered = false;
      this.cleanLocalStorage();
      this.clearInactivityTimer();
      if (this.loggedIn) {
        this.eventerApi
          .get("logout")
          .then(() => {})
          .catch((error) => {
            console.log("Couldnt logout.", error);
          });
      }
      this.loggedIn = false;
      this.registering = false;
      this.submitted = false;
      this.currentStep = 1;
      this.modelPayments = [];
      this.maxStep = 1;
      localStorage.clear();
      this.goToLoginPage();
      this.showPassword = false;
    },
    translateCompanyData() {
      this.companyDataSchema.title = this.$t("companyData");
      this.companyDataSchema.desc = this.$t("companyData");
      this.companyDataSchema.properties.name.title = this.$t("compName");
      this.companyDataSchema.properties.fiscalCode.title =
        this.$t("fiscalCode");
      this.companyDataSchema.properties.registryNumber.title =
        this.$t("registryNumber");
      this.companyDataSchema.properties.address.title = this.$t("address");
      this.companyDataSchema.properties.city.title = this.$t("participantCity");
      this.companyDataSchema.properties.bank.title = this.$t("bank");
    },
    loadEventData(changeStep) {
    this.loading = true;  
      const endPointUrl =
      process.env.VUE_APP_BACKEND +
      "participant/registration/register/" +
      this.eventId;

    axios
      .get(endPointUrl)
      .catch((error) => {
        console.log(error);
        this.registering = false;
        this.loggedIn = false;
        this.loadingError = "error.loadingError." + error.response.status;
        this.loading = false;
      })
      //finally is called before then, so we end up rendering the html before we actually have the data
      //.finally(() => { this.loading = false})
      .then((response) => {
        this.loading = false;
        if (!response) {
          return;
        }

        let enTranslate = {};
        let roTranslate = {};

        this.serverData = response.data;
        roTranslate[this.serverData.bankTransfer] =
          this.serverData.bankTransfer;
        roTranslate[this.serverData.dataProtection] =
          this.serverData.dataProtection;
        roTranslate[this.serverData.note] = this.serverData.note;
        roTranslate[this.serverData.taxInfo] = this.serverData.taxInfo;
        roTranslate[this.serverData.title] = this.serverData.title;
        enTranslate[this.serverData.bankTransfer] =
          this.serverData.bankTransferEng?.length > 0
            ? this.serverData.bankTransferEng
            : null;
        enTranslate[this.serverData.dataProtection] =
          this.serverData.dataProtectionEng?.length > 0
            ? this.serverData.dataProtectionEng
            : null;
        enTranslate[this.serverData.note] =
          this.serverData.noteEng?.length > 0 ? this.serverData.noteEng : null;
        enTranslate[this.serverData.taxInfo] =
          this.serverData.taxInfoEng?.length > 0
            ? this.serverData.taxInfoEng
            : null;
        enTranslate[this.serverData.title] =
          this.serverData.titleEng?.length > 0
            ? this.serverData.titleEng
            : null;
        if (
          this.serverData.attendanceTypes &&
          this.serverData.attendanceTypes.length == 1
        ) {
          this.participant.services.participationType =
            this.serverData.attendanceTypes[0].id;
        }
        this.serverData.attendanceTypes.forEach((aType) => {
          roTranslate[aType.name] = aType.name;
          enTranslate[aType.name] =
            aType.nameEng?.length > 0 ? aType.nameEng : null;
        });
        this.serverData.participantTypes.forEach((pType) => {
          //add participant types to schema
          //split data by participant type
          let participantTypeData = {
            eventTax: [],
            requiredServiceClasses: [],
            optionalServiceClasses: [],
            eventHotels: [],
          };
          this.serverData[pType.id] = participantTypeData;
          roTranslate[pType.name] = pType.name;
          enTranslate[pType.name] =
            pType.nameEng?.length > 0 ? pType.nameEng : null;
        });
        //set each participant type event tax
        this.serverData.taxes.forEach((tax) => {
          tax.participantTypes.forEach((pType) => {
            this.serverData[pType.id].eventTax.push(tax);
          });
          roTranslate[tax.description] = tax.description;
          enTranslate[tax.description] =
            tax.descriptionEng?.length > 0 ? tax.descriptionEng : null;
        });
        //process service classes to group them by participant type
        this.serverData.services.forEach((serviceClass) => {
          serviceClass.services.forEach((service) => {
            //stores participant type and it's services
            const participantServices = {};
            service.participantTypes.forEach((pType) => {
              participantServices[pType.id] = [];
              //check prices for participant
              service.prices.forEach((price) => {
                if (
                  price.participantTypes.some((type) => type.id == pType.id)
                ) {
                  const newService = Object.assign({}, service);
                  //add the service with the price extended information
                  newService.price = price.amount;
                  participantServices[pType.id].push(newService);
                }
              });
            });
            //now add the class with service for each participant type
            Object.keys(participantServices).forEach((key) => {
              if (participantServices[key].length > 0) {
                const newServiceClass = Object.assign({}, serviceClass);
                newServiceClass.services = participantServices[key];
                if (serviceClass.required) {
                  this.serverData[key].requiredServiceClasses.push(
                    newServiceClass
                  );
                } else {
                  this.serverData[key].optionalServiceClasses.push(
                    newServiceClass
                  );
                }
              }
            });
            roTranslate[service.name] = service.name;
            enTranslate[service.name] =
              service.nameEng?.length > 0 ? service.nameEng : null;
            roTranslate[service.description] = service.description;
            enTranslate[service.description] =
              service.descriptionEng?.length > 0
                ? service.descriptionEng
                : null;
          });
          roTranslate[serviceClass.name] = serviceClass.name;
          enTranslate[serviceClass.name] =
            serviceClass.nameEng?.length > 0 ? serviceClass.nameEng : null;
        });
        //process hotels to split them by participant type
        this.serverData.hotels.concat(this.serverData.expiredHotels).forEach((hotel) => {
          const participantRooms = {};
          hotel.rooms.concat(hotel.expiredRooms).forEach((room) => {
            let prices = room.prices;
            let expired=false;
            if(!prices || prices.length==0){
              prices = room.expiredPrices;
              expired = true;
            }
            prices.concat().forEach((price) => {
              const extendedRoom = Object.assign(
                { price: price.amount, validUntil: price.endDate, expired : expired },
                room
              );
              price.participantTypes.forEach((pType) => {
                if (!participantRooms[pType.id]) {
                  participantRooms[pType.id] = [];
                }
                participantRooms[pType.id].push(extendedRoom);
              });
            });
            roTranslate[room.name] = room.name;
            enTranslate[room.name] =
              room.nameEng?.length > 0 ? room.nameEng : null;
          });
          //now add the hotel with rooms for each participant type
          Object.keys(participantRooms).forEach((key) => {
            if (participantRooms[key].length > 0) {
              //calculate max and min price
              let minPrice = undefined;
              let maxPrice = undefined;
              participantRooms[key].forEach((room) => {
                if (minPrice == undefined || minPrice > room.price) {
                  minPrice = room.price;
                }
                if (maxPrice == undefined || maxPrice < room.price) {
                  maxPrice = room.price;
                }
              });
              const newHotel = Object.assign(
                { minPrice: minPrice, maxPrice: maxPrice },
                hotel
              );
              newHotel.rooms = participantRooms[key];
              this.serverData[key].eventHotels.push(newHotel);
            }
          });
          roTranslate[hotel.name] = hotel.name;
          enTranslate[hotel.name] =
            hotel.nameEng?.length > 0 ? hotel.nameEng : null;
        });

        if(changeStep){
          if (this.registering) {
            this.setFromLocalStorage("modelPayment");
            // this.updateDataForParticipantType(this.participant);
          }
          if (this.loggedIn && localStorage.getItem("tkn")) {
            
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("tkn")}`;
            //try to get user info
            this.getParticipantInfo(true);
            this.changes = false;
          }
        }
        this.serverData.presentationTypes.forEach((pt) => {
          roTranslate[pt.name] = pt.name;
          enTranslate[pt.name] = pt.nameEng?.length > 0 ? pt.nameEng : null;
        });
        this.serverData.themes.forEach((t) => {
          roTranslate[t.name] = t.name;
          enTranslate[t.name] = t.nameEng?.length > 0 ? t.nameEng : null;
        });
        this.$i18n.setLocaleMessage("en", {
          ...this.$i18n.messages.en,
          ...enTranslate,
        });
        this.$i18n.setLocaleMessage("ro", {
          ...this.$i18n.messages.ro,
          ...roTranslate,
        });
        if(this.serverData.defaultLanguage){
          this.changeLang(this.serverData.defaultLanguage);
        }
      });

    
    },
    
    setLoginToken(token){
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      localStorage.setItem("tkn",token);
      // this.loading = false;
      //login the user
      this.loggedIn = true;
      this.saveToLocalStorage("loggedIn", this.loggedIn);
      this.registering = false;
      this.loginError = "";
      this.drawer = !this.isMobile;
    }
  },
  watch: {
    loggedIn : function(){
      Vue.notify({
        group: 'app',
        clear: true
      });
    },
    confirmContinueRegistration: function () {
      setTimeout(() => {
        this.observeHeight();
      }, 0);
    },
    registering: function (val) {
      if (val == true) {
        setTimeout(() => {
          this.observeHeight();
        }, 0);
      }
    },
    login: function (val) {
      if (val == true) {
        setTimeout(() => {
          this.observeHeight();
        }, 0);
      }
    },
    modelPayment: function () {
      this.saveToLocalStorage("modelPayment");
    },
    currentStep(newValue) {
      this.maxStep = newValue > this.maxStep ? newValue : this.maxStep;
      localStorage.currentStep = this.currentStep;
      localStorage.maxStep = this.maxStep;
      //make sure to set the participationt type when going to taxes and nothig  set
      if (
        newValue == 2 &&
        this.participant.services?.participationType == undefined
      ) {
        if (
          this.serverData.attendanceTypes &&
          this.serverData.attendanceTypes.length == 1
        ) {
          this.participant.services.participationType =
            this.serverData.attendanceTypes[0].id;
        }
      }
    }
  },

  metaInfo() {
    return {
      title: `Inregistrare eveniment ${this.serverData.title}`,
      meta: [],
    };
  },
  created() {
    document.addEventListener('mousemove', this.handleUserActivity);
    document.addEventListener('touchstart', this.handleUserActivity);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleUserActivity);
    document.removeEventListener('touchstart', this.handleUserActivity);
  },
  mounted() {
    this.modelPayments = [];
    //set initial height
    this.sendContentHeightToParent(this.minParentHeight);
    this.observeHeight();
    this.companyDataSchema.i18n = this.$i18n.messages;
    this.translateCompanyData();
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let eventId = params.get("eventId");
    console.log("paramEventId", eventId);
    if(!eventId){
      console.log("localStorage.getItem(eventId)", localStorage.getItem("eventId"));
      eventId = localStorage.getItem("eventId");
    }
    console.log("result eventId", eventId);
    localStorage.setItem("eventId", eventId);
    let token = params.get("token");
    if(token){
      this.setLoginToken(token);
    }
    const action = params.get("action");
    if (action == "reset") {
      this.resetPassword = true;
    }
    // sync participant with localStorage
    if (localStorage.registering) {
      this.registering = true;
      this.confirmContinueRegistration = true;
    } else {
      this.confirmContinueRegistration = false;
    }

    if (localStorage.loggedIn) {
      this.loggedIn = localStorage.loggedIn === "true";
    }
    // ------------------------------------

    if (!eventId) {
      this.loadingError = "error.noEventId";
      this.loading = false;
    } else {
      this.eventId = eventId;
      this.loadEventData(true);
    }
  },
};
</script>

<style scoped>
.header_card_selected {
  background-color: rgb(236, 236, 236);
}
body {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.v-card {
  padding: 10px;
  margin-bottom: 10px;
}

.text-align-center {
  text-align: center;
}

.flex-top-align {
  align-self: flex-start;
}

.margin-b-30 {
  margin-bottom: 25px;
}

/* This is for documentation purposes and will not be needed in your application */
.v-speed-dial {
  z-index: 20;
  bottom: 29px;
}

.v-stepper__header {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  height: 80px !important;
}

.v-stepper__header {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  height: 80px;
}

.v-stepper {
  margin-top: 40px;
}

.stepperRegister {
  margin-top: 85px;
}

.stepperRegister_mobile {
  margin-top: 10px !important;
}

.v-stepper__content {
  /* margin-bottom: 30px; */
  overflow-y: auto;
}

.v-stepper__step {
  cursor: pointer;
}

/* ############### v-stepper */
.v-btn--floating {
  position: relative;
}

#app > div > main > div > div.container.fill-height > div.container {
  position: fixed;
  top: 15px;
}

.show-on-low-res {
  display: none;
}

@media only screen and (min-width: 801px) and (max-width: 959px) {
  /* overeride default vue */
  #stepper::v-deep .v-stepper__label {
    display: flex !important;
  }
}

@media only screen and (max-width: 800px) {
  .show-on-low-res {
    display: block;
  }

  /* overeride default vue */
  #stepper::v-deep .v-stepper__label {
    display: none;
  }
}
.v-navigation-drawer {
  .v-card__title {
    padding: unset;
  }
  .v-card {
    padding-bottom: 0px;
  }
}

.theme--light.v-bottom-navigation .v-btn {
  color : white !important;
  margin-left: 10px;
  margin-right: 10px;
}

.not_completed {
  .v-stepper__step__step{
    background-color: #8080804d !important;
  }
}

#loggedInMenu{
  max-width : 30%;
}

</style>